//Core modules
import React, {Fragment, useEffect, useState} from 'react';

//External modules

//Internal modules.
import requestApi from "../../../services/requestApi.service";
import {handleErrorResponse} from "../../../Common/Appcommon";
import TableList from '../../../Common/TableList';
import FieldsMapping from '../../../Common/FieldsMapping';

const GoogleAds = (props) => {

    const [adForms, setAdForms] = useState({});
    const [showMapping, setShowMapping] = useState(false);
    const [adFormInfo, setAdFormInfo] = useState({});
    const [listfieldsname,setListFieldsName] = useState([['Form ID','Campaign ID','Edit'],['1','2','0']])

    useEffect(() => {
        (async () => {
            await getFormsList();
        })();
    },[]);

    const getFormsList = async () => {
        let params = {
            "ENTITY": "GOOGLEADSPROCESS",
            "OPERATION" : 'GETALL'
        }
        let response = await requestApi.processServerRequest(params);

        if(response.issuccess){
            setAdForms(response.data);
        }else{
            handleErrorResponse(response.errormsg);
        }
    }

    const ShowEditScreen = (formData) => {
        setAdFormInfo(formData);
        setShowMapping(true);
    }

    const hideEditScreen = () => {
        setShowMapping(false);
        setAdFormInfo({});
    }

    const renderElements = (name,formData,field) => {
        if(name === 'editform'){
            return <div className={`le-clickable`} onClick={()=>{ShowEditScreen(formData)}}>{`edit`}</div>
        }
    }

    return (
        <Fragment>
            {
                !showMapping &&
                <TableList
                    onBackAction={props.onBackAction}
                    adForms={adForms}
                    renderElements={renderElements}
                    webhookform={"Customize/googleads/webhook.php"}
                    titlename={"Connected Google Ads Forms"}
                    listfieldsname={listfieldsname}
                />
            }
            {
                showMapping &&
                <FieldsMapping
                    showMapping={showMapping}
                    formInfo={adFormInfo}
                    onBackAction={hideEditScreen}
                    screen ={"Googleads"}
                    mappingColumns = ""
                    leadstatus = ""
                />
            }
        </Fragment>
    );
}

export default GoogleAds;
